import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Joins class names and resolves Tailwind conflicts, last one winning.
 *
 * Every component in this package takes a `className` and merges it through here rather than
 * concatenating, because a caller passing `p-6` to a component whose base is `p-4` must get `p-6`
 * and not both. Plain concatenation leaves the outcome to the order the two rules happen to appear
 * in the generated stylesheet, which is a layout that changes when an unrelated file is edited.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
